// extracted by mini-css-extract-plugin
export default {"itemsContainer":"Menu_itemsContainer__08smG"};